// extracted by mini-css-extract-plugin
export default {"s_link":"link_s_link__eJZgM"};